<template>
  <tr v-if="prices">
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
      <v-row align="center" no-gutters>
        <v-icon x-small class="mx-1 mr-2">mdi-help-circle-outline</v-icon> Min/Max Inventory
      </v-row>
    </th>
    <td class="sheet-cell" v-for="(price, index) in prices" :key="index">

      <v-progress-circular v-if="price.miu" size="12" width="2" indeterminate style="width: 50%"/>
      <input v-else v-model.lazy="price.min_inventory" class="sheet-input-left" @change="updateMinInventory(price)"/>

      <v-progress-circular v-if="price.mau" size="12" width="2" indeterminate style="width: 50%"/>
      <input v-else v-model.lazy="price.max_inventory" class="sheet-input-right" @change="updateMaxInventory(price)"/>

    </td>
  </tr>
</template>


<script>
  import sheet_repository from "@/repositories/sheet-repository";

  export default {
    props: {
      prices: null
    },

    methods: {

      async updateMinInventory(data) {
        try {
          this.$set(data, 'miu', true);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'miu', false);
        }
      },

      async updateMaxInventory(data) {
        try {
          this.$set(data, 'mau', true);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'mau', false);
        }
      }

    }
  }
</script>


<style scoped>
  @import '../sheet.css';
</style>